var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#AD7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6196 15.2323C13.2209 15.2323 13.7084 14.7448 13.7084 14.1435C13.7084 13.5422 13.2209 13.0547 12.6196 13.0547C12.0183 13.0547 11.5308 13.5422 11.5308 14.1435C11.5308 14.7448 12.0183 15.2323 12.6196 15.2323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.3699 15.2323C19.9712 15.2323 20.4587 14.7448 20.4587 14.1435C20.4587 13.5422 19.9712 13.0547 19.3699 13.0547C18.7686 13.0547 18.2811 13.5422 18.2811 14.1435C18.2811 14.7448 18.7686 15.2323 19.3699 15.2323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0311 19.4739C14.3305 19.4739 13.1173 18.8103 13.0447 18.7688C12.7959 18.6236 12.7025 18.3126 12.8477 18.0637C12.9825 17.8148 13.304 17.7215 13.5528 17.8667C13.6462 17.9185 15.9067 19.1421 18.4679 17.8563C18.7272 17.7319 19.0383 17.8356 19.1627 18.0844C19.2871 18.3437 19.1834 18.6547 18.9346 18.7792C17.8976 19.2977 16.9022 19.4739 16.0311 19.4739Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUserIcon);
export default __webpack_public_path__ + "static/media/ico_user_icon.96c73b90a5e115b2d6bcc775c193f73f.svg";
export { ForwardRef as ReactComponent };